<template>
  <div>

  </div>
</template>

<script>
  import ResultModel from "@/models/modus/ResultModel";

  export default {
    name: 'ResultSandbox',
    data() {
      return {
        id: (this.$route.params.id || null),
        result: null,
        translator: null,
      };
    },
    created() {
      let result = new ResultModel();
      result.set('id', this.id);
      result.fetch().then(() => {
        this.result = result;
      });
    },
  }
</script>
